import React from "react";
import { useEffect } from "react";
import "../App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Col, Container, Row } from "react-bootstrap";

export default function TournamentBanner() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <section className="tournament" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            {/* <button onClick={() => console.log("connect")}>
            Let's Connect <ArrowRightCircle size={25} />
          </button> */}
          </Col>
          <Col xs={12} md={6} xl={5}>
            {/* <img src={headerImg} alt="Header img" /> */}
          </Col>
        </Row>
      </Container>
    </section>
  );
}
